<template>
  <div :class="{row: horizontal, 'align-items-center': horizontal}">
    <label v-if="!hiddenLabel" :class="labelClass">
      {{ $t('bank_accounts.my_account') }}
      <span class="color-red">* </span>
    </label>
    <div :class="inputClass">
      <select id="sel2" readonly :disabled="disabled"
        v-model="senderBank"
        class="form-control min-h-30px border-radius-10px" :class="{'errorBorder': senderBankError}">
        <option value="">{{ $t('creation_forms.slct_an_acc') }}</option>
        <option v-for="bankAccount in bankAccounts" :key="bankAccount.id" :value="bankAccount.iban" :disabled="!isBankAccountAvailable(bankAccount)">
          {{ bankAccount.name }} ({{ $engine.bankAccounts.getCurrency(bankAccount.zoneCode) }})
        </option>
      </select>
      <i v-if="inputIcon" size="17px" class="color-black" :class="inputIcon"></i>
    </div>
    <div v-if="senderBankError" class="color-red">
      {{ $t('errors.is_mandatory', { mandatoryValue : $t('common.act') }) }}
    </div>
  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'

export default {
  name: 'selectBankAccount',
  data: () => {
    return {
      bankAccounts: [],
      senderBankName: '',
      senderBankError: false
    }
  },
  components: {
    'form-accordion': FormAccordion
  },
  props: {
    labelClass: {
      type: String,
      default: 'createInvoiceBand'
    },
    value: {
      type: String,
      default: ''
    },
    default: {
      type: Boolean,
      default: true
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    senderBank: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  created () {
    this.bankAccounts = this.$engine.bankAccounts.get()
    if (!this.senderBank && this.default) {
      this.senderBank = this.bankAccounts.filter(bkAct => { return bkAct.isDefault === '1' })
      if (this.senderBank.length > 0) {
        this.senderBank = this.senderBank[0].iban
      } else {
        this.senderBank = ''
      }
    }
  },
  mounted () {
    this.$engine.services.payments.contactDebtorList = []
    if ((!this.senderBank || !this.senderBankName) && this.default) {
      let defaultBankAccount = this.$engine.bankAccounts.get().find(elem => elem.isDefault === '1')
      if (defaultBankAccount) {
        if (!this.senderBank && defaultBankAccount.iban) {
          this.senderBank = defaultBankAccount.iban
        }
        if (!this.senderBankName && defaultBankAccount.name) {
          this.senderBankName = defaultBankAccount.name
        }
      }
    }
  },
  methods: {
    isBankAccountAvailable (bankAccount) {
      if (this.$engine.rights.rightIs('rtp_request_other_euro', false)) {
        return bankAccount.zoneCode === 'EUR'
      }
      return true
    }
  }
}
</script>
